import {GENE} from "./EnvItems";

const BFF_BASE = (() => {
  switch (process.env.REACT_APP_ENV) {
    case "production":
      return "https://hvyypnaecf.execute-api.ap-northeast-1.amazonaws.com/latest";
    case "staging":
      return "https://dh6yzksz0d.execute-api.ap-northeast-1.amazonaws.com/latest";
    default:
      return "https://dh6yzksz0d.execute-api.ap-northeast-1.amazonaws.com/latest";
  }
})();

const SHINAGAWA_BFF_BASE = (() => {
  switch (process.env.REACT_APP_ENV) {
    case "production":
      return "https://k81a8q359f.execute-api.ap-northeast-1.amazonaws.com/latest";
    case "staging":
      return "https://noyuzpi20i.execute-api.ap-northeast-1.amazonaws.com/latest";
    default:
      return "https://noyuzpi20i.execute-api.ap-northeast-1.amazonaws.com/latest";
  }
})();

export const COVID_19_HEALTH_HAZARD_SCORE = (() => {
   return "https://hazardscore.genesis-healthcare.jp/covid19";
})();

export const COVID_19_RESEARCH = (() => {
  return "https://www.surveymonkey.com/r/P7PXKJN";
})();

export const COVID_19_PCR_SALES = (() => {
  return "https://genelife.jp/covid19pcr";
})();

function paramCategories(categories) {
  return categories ? "&categories=" + categories : "";
}

function URL_DISEASE(token, gender, kit, categories) {
  return BFF_BASE + "?token=" + token + "&gender=" + gender + "&kit=" + kit + "&type=disease&f=summary" + paramCategories(categories);
}

function URL_CONSTITUTION(token, gender, kit, categories) {
  return BFF_BASE + "?token=" + token + "&gender=" + gender + "&kit=" + kit + "&type=constitution&f=summary" + paramCategories(categories);
}

function URL_RISKLEVEL(token, gender, kit, categories) {
  return BFF_BASE + "?token=" + token + "&gender=" + gender + "&kit=" + kit + "&type=risk_level&f=summary" + paramCategories(categories);
}

function URL_CANCER(token, gender, kit) {
  return BFF_BASE + "?token=" + token + "&gender=" + gender + "&kit=" + kit + "&type=cancer&f=summary";
}

function URL_SEVENS(token, gender, kit) {
  return BFF_BASE + "?token=" + token + "&gender=" + gender + "&kit=" + kit + "&type=sevens&f=summary";
}

function URL_COVID(token, gender, kit) {
  return BFF_BASE + "?token=" + token + "&gender=" + gender + "&kit=" + kit + "&type=unclassified&f=summary&categories=37";
}

function URL_BIQ_DISCOVERY(token, gender, kit) {
  return BFF_BASE + "?token=" + token + "&gender=" + gender + "&kit=" + kit + "&type=big_discovery&f=summary";
}

function URL_DETAIL(token, kit, unit) {
  return BFF_BASE + "?token=" + token + "&kit=" + kit + "&f=detail&unit=" +unit;
}

function URL_INFO(gene) {
  return BFF_BASE + `?f=info&${GENE}=`+gene;
}

function URL_SEARCH_ITEM(gender) {
  return BFF_BASE + "?f=search&gender="+gender;
}

function USER_COMMUNICATION_BOOK(token, kit) {
  return BFF_BASE + "?f=communication_book&token=" + token + "&kit=" + kit;
}

const URL_GET_NUTRIENTS = (customer_id, dhc_no) => {
  return SHINAGAWA_BFF_BASE + "/affiliates/withkey/nutrients?dhc_no=" + dhc_no + "&customer_id=" + customer_id;
};

const URL_REDIRECT_AFFILIATE = (dhc_no) => {
  const link_url_number = (dhc_no + 41).toString(36).toUpperCase();
  return `http://cm-12862.csolution.jp/c.neo/af/9xa.${link_url_number}/-/9x9.html`;
};

const URL_GET_AFFILIATE_AGREEMENTS = (customer_id) => {
  return SHINAGAWA_BFF_BASE + "/affiliates/withkey/agreements?customer_id=" + customer_id;
};

export const MYPAGE_URL = "https://www.genelife.jp";


export {URL_DISEASE, URL_CANCER, URL_RISKLEVEL, URL_CONSTITUTION, URL_DETAIL, URL_SEVENS, URL_INFO, URL_SEARCH_ITEM, USER_COMMUNICATION_BOOK, URL_REDIRECT_AFFILIATE, URL_GET_NUTRIENTS , URL_GET_AFFILIATE_AGREEMENTS, URL_BIQ_DISCOVERY, URL_COVID};



// WEBPACK FOOTER //
// ./src/constants/Url.js